/**
 * @generated SignedSource<<1d228f11599095b51c959ca5abae6d78>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionHistoryItemFragment$data = {
  readonly createdAt: DateTime;
  readonly publishedAt: DateTime | null | undefined;
  readonly version: Semver;
  readonly viewerCanDelete: boolean;
  readonly viewerCanUpdate: boolean;
  readonly workspace: {
    readonly slug: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionDeleteButtonFragment" | "WorkspaceVersionRenameButtonFragment">;
  readonly " $fragmentType": "WorkspaceVersionHistoryItemFragment";
};
export type WorkspaceVersionHistoryItemFragment$key = {
  readonly " $data"?: WorkspaceVersionHistoryItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionHistoryItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionHistoryItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanDelete",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "DELETE_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"DELETE_WORKSPACE_VERSION\")"
    },
    {
      "alias": "viewerCanUpdate",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE_VERSION\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionDeleteButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionRenameButtonFragment"
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};

(node as any).hash = "d933563e908f980880f1e6d3cd30b6de";

export default node;
